import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative py-16 flex flex-col items-center justify-center bg-transparent overflow-hidden px-4" data-id="element-125">
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-126">
        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="relative mb-8 inline-block" data-id="element-127">
          <motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-128">
            <a href="https://pay.hotmart.com/D104310882V?bid=1770407336992" target="_blank" rel="noopener noreferrer" className="block relative z-10 group" data-id="element-129">
              <img src="https://cdn.magicpatterns.com/uploads/w6xCwDnec1XDHdyMMWNapW/Ansiedad_expres_optimized.png" alt="Ansiedad Exprés" className="w-full max-w-[280px] md:max-w-[380px] rounded-xl shadow-xl shadow-black/5 border border-[#E8E8E6] rotate-1 group-hover:rotate-0 transition-transform duration-700 ease-out" data-id="element-130" />
            </a>
          </motion.div>
        </motion.div>

        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} data-id="element-131">
          <h1 className="text-4xl md:text-5xl font-semibold text-[#3A3A3A] mb-4 tracking-tight" data-id="element-132">
            Ansiedad Exprés
          </h1>
          <p className="text-xl text-[#7A7A7A] font-light max-w-2xl mx-auto" data-id="element-133">
            Protocolo de 5 minutos para recuperar el control
          </p>

          <a href="#anxiety-test" className="inline-block mt-8" data-id="element-134">
            <Button variant="outline" size="lg" withIcon data-id="element-135">
              Descubre tu nivel de ansiedad
            </Button>
          </a>
        </motion.div>
      </div>
    </section>;
}